class ProductCategoriesFilter {
    constructor() {
        this.categoryButtons = document.querySelectorAll('.products__category--link');
        this.body = document.querySelector('body');
        this.bodyClassList = this.body.classList;

        if (this.categoryButtons && this.body) {
            this.events();
        }
    }

    events() {
        const bodyClasses = Array.from(this.body.classList);
    
        this.categoryButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.categoryButtons.forEach(btn => {
                    if (btn !== button && btn.classList.contains('selected')) {
                        btn.classList.remove('selected');
                    }
                });

                if (!button.classList.contains('selected')) {
                    button.classList.add('selected');
                }

                const buttonData = button.getAttribute('data-category');
                if (bodyClasses.includes(buttonData)) {
                    const homepageURL = window.location.origin;
                    button.href = homepageURL + '/nasze-produkty';
                }
            });
        });
    }
}

export default ProductCategoriesFilter;
